import axios from 'axios';
import type { Dispatch } from 'redux';

import type { VendorSublet } from './types';

export const LOAD_VENDOR_SUBLETS_SUCCESS = 'LOAD_VENDOR_SUBLETS_SUCCESS';
export const UPDATE_VENDOR_SUBLET_SUCCESS = 'UPDATE_VENDOR_SUBLETS_SUCCESS';

export const loadVendorSubletsSuccess = (vendorSublets: VendorSublet[]) => ({
  type: LOAD_VENDOR_SUBLETS_SUCCESS,
  vendorSublets,
});

export const updateVendorSubletSuccess = (vendorSublet: VendorSublet) => ({
  type: UPDATE_VENDOR_SUBLET_SUCCESS,
  vendorSublet,
});

export const loadVendorSublets = (vehicleId: string) => (dispatch: Dispatch<any>) => {
  return axios
    .get<PaginatedResults<VendorSublet>>('/vendor-sublets/', {
      params: { vehicle: vehicleId, page_size: 1000 },
    })
    .then((response) => {
      dispatch(loadVendorSubletsSuccess(response.data.results));
    });
};
